const Configdata = {
    ischatscroll: true,
    name: 'world chat',
 /*    srvurl: 'http://127.0.0.1:5000',  */

/*  srvurl: 'http://localhost:8000',  */
  
   srvurl: 'https://69.197.168.84:8000',   


   pfppath: '/ind/'
   

}

export default Configdata;


